import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "../styles/linkbuilding_2.css";

handleFloatingPromise(initExpertSite());
